import "./InfoMessage.scss";
import { useTranslation } from "react-i18next";

export default function CopyMessage() {
      const { t } = useTranslation();
  return (
    <div className="info-message-wrapper">
      <div className="check"></div>
      <div className="message">{t('copied')}</div>
    </div>
  );
}
